/* eslint no-param-reassign: "error" */

export default {
  SET_ACCOUNT(state, data) {
    state.name = data.name;
  },

  CLEAR_ACCOUNT(state) {
    state.name = null;
  },
};
